import { MenuIcon } from '@braskai/icons';

import { SIconButton } from './styled';

export type TBurgerButtonProps = {
  'data-testid'?: string;
  onClick: () => void;
};

export const BurgerButton = ({ 'data-testid': dataTestId = 'burger-button-open-sidebar', onClick }: TBurgerButtonProps) => (
  <SIconButton aria-label="open sidebar" data-testid={dataTestId} onClick={onClick}>
    <MenuIcon height={20} width={20} />
  </SIconButton>
);
